import styled, { css } from 'styled-components';
import { Sheet } from 'react-modal-sheet';
import { SheetModalProps } from './SheetModal';

export const SheetModalContent = styled.div`
	padding: 0 8px 24px 8px;
	width: 100%;
	height: 100%;
`;

export const SheetModalHeaderContainer = styled.div`
	width: 100%;
	padding: 0 8px;
	margin-bottom: 14px;
`;

export const SheetModalHeaderDragIndicator = styled.div`
	width: 94px;
	height: 4px;
	border-radius: 99px;
	background-color: rgb(221, 221, 221);
	margin: 20px 0;
`;

export const SheetModalHeaderTitle = styled.div`
	${({ theme }) => css`
		font-size: ${theme.fontSizes.default};
		font-weight: ${theme.fontWeights.bold};
		color: ${theme.colors.brand.text};
		text-transform: uppercase;
	`}
`;

export const SheetModalHeaderIconContainer = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		width: 38px;
		height: 38px;
		border-radius: ${theme.radii.m};
		background-color: ${theme.colors.neutral[200]};
	`}
`;

export const SheetModalContainer = styled(Sheet.Container)<SheetModalProps>`
	${({ heightPercentage }) => css`
		${heightPercentage && css`
			height: calc(var(--vh, 1vh) * ${heightPercentage}) !important;
		`}
		${!heightPercentage && css`
			height: auto !important;
		`}
	`}
`;
